import { useEffect } from "react"
import { Privacy, Grid } from "../components"
import { Navbar, Footer } from "../layouts"




const Privac = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])

    return (
        <>
        <Navbar/>
        <Grid/>
        <Privacy/>
        <Footer/>
        </>

    )
}

export default Privac